import Card from "../../../models/common/Card";
// import iconOne from '../../../assets/img/partnerProgram/fill_1.png';
// import iconTwo from '../../../assets/img/partnerProgram/fill_2.png';
// import iconThird from '../../../assets/img/partnerProgram/fill_3.png';
// import iconFour from '../../../assets/img/partnerProgram/fill_4.png';
// import iconFive from '../../../assets/img/partnerProgram/fill_5.png';
import iconOne from '../../../assets/img/partnerPortal/customSolution/icon1.svg';
import iconTwo from '../../../assets/img/partnerPortal/customSolution/icon2.svg';
import iconThird from '../../../assets/img/partnerPortal/customSolution/icon3.svg';
import iconFour from '../../../assets/img/partnerPortal/customSolution/icon4.svg';
import iconFive from '../../../assets/img/partnerPortal/customSolution/icon5.svg';
import iconsix from '../../../assets/img/partnerPortal/customSolution/icon6.svg';
import edgeConnected from '../../../assets/img/partnerPortal/customSolution/EdgeConnect.svg';
const ENABLEMENT_PAGE = "https://partners.dynatrace.com/#/page/enablement";

// BANNER
export const TITLE = <div>Custom Solutions powered<br/> by Dynatrace® AppEngine</div>;
export const SUB_TITLE = <div>Extend Dynatrace with intuitive custom solutions that are secure, enterprise-grade and easy to build.</div>;
export const BUTTON_NAME = "Get started";
export const BUTTON_LINK = "https://university.dynatrace.com/ondemand/course/35226?content=overview";
// --

// INTRODUCTION TEXT
//export const INTRO_EYE_BROWN_HEADER = "HOW IT WORKS";
export const TITLE_1 = "Custom Solutions at your fingertips";
export const INTRO_TEXT = <div>
                            Dynatrace seamlessly combines the best of both worlds: a unified
                            observability and security platform that works out of the box, along
                            with the opportunity for partners to create powerful apps, delivering
                            custom solutions for their clients.
                          </div>;

export const TITLE_2 = "An open and extensible platform for custom use cases";
export const TEXT_2 = <div>
                            Custom apps let you tailor any aspect of the Dynatrace platform allowing you to create new use cases
                            by combining observability with security data without losing business context. With access to all capabilities
                            of the Dynatrace platform, including Smartscape, Davis® AI or Grail™, you can build apps with intelligent
                            automation and deliver precise answers to your clients, by applying logic to the data stored in Grail.
                      </div>;

export const TITLE_3 = "Why build on top of Dynatrace";
export const TEXT_3 = <div>
                            Dynatrace is a governed all-in-one platform that powers your custom solutions in a secure, compliant, scalable,
                            and enterprise-ready way right from the beginning.
                            This means you can focus on bringing custom logic to the data in Grail without having to architect, operate
                            and maintain the underlying runtime environment. And since your Dynatrace® App runs close to where the data is
                            captured and stored, you don’t need to worry about exporting the data and keeping it secure.
                            Dynatrace makes sure your application is secure, compliant, and scalable to meet the requirements
                            of large enterprises.
                      </div>;
// --

// BENEFITS CARDS
export const EYE_BROWN_HEADER_CARDS = "WHY JOIN";
export const TITLE_CARDS = <div>What are the benefits of a governed,<br/> enterprise-ready platform?</div>;
export const SUB_TITLE_CARDS = "Here's what's in it for you:";
const card1: Card = new Card("", "1. Control what data is being processed and encrypt, mask or filter data on ingest.", iconOne);
const card2: Card = new Card("", "2. Define user context policies to make sure that the application’s data access is in line with the permissions granted to a specific user.", iconTwo);
const card3: Card = new Card("", "3. Protect against potential compromises with the code shielding technology included within the runtime environment.", iconThird);
const card4: Card = new Card("", "4. Use the powerful permissions and policies system that allows you to exercise granular control over the core platform and its components like Davis AI.", iconFour);
const card5: Card = new Card("", "5. Let the Dynatrace Hub take care of the end-to-end application management, including ship, deploy, and update of apps.", iconFive);
const card6: Card = new Card("", "6. Create trust with certified and signed apps that have a specific app scope to ensure that the customer is in control.", iconsix);
const card7: Card = new Card("", "7. Securely integrate external environments/apps: fetch or import external data and rely on secure remote invocations in private networks using EdgeConnect.", edgeConnected, undefined, undefined, "25%");
const cardsFirstRow: Card[] = [card1, card2, card3];
const cardsSecondRow: Card[] = [card4, card5, card6];
const cardsThirdRow: Card[] = [card7];

export const ALL_CARD_ROWS: Record<number, Card[]> = {
  [0]: cardsFirstRow,
  [1]: cardsSecondRow,
  [2]: cardsThirdRow
}

// Get inspired
export const TEXT_STEP_1 = <div>Find out how you can <a href="https://www.dynatrace.com/news/blog/automate-your-work-with-unified-observability-and-custom-solutions/">automate work with unified observability and custom solutions</a> and discover a wide range of practical examples.</div>;
export const TEXT_STEP_2 = <div>Head over to <a href="https://developer.dynatrace.com/">dynatrace.dev</a> for more information on how to get started with your first app in under 5 minutes.</div>;
export const TEXT_STEP_3 = <div>Go to Dynatrace University and get <a href="https://partners.dynatrace.com/#/page/app-developer">App Developer Certified</a>. This will enable you to build high-quality and secure Dynatrace Apps and build trust with your customers.</div>;
export const TEXT_STEP_4 = <div>Reach out to <a href="mailto:customsolutions@dynatrace.com">custom solutions</a> for support and questions around your use case.</div>;


// CONTENT BLOCKER
export const EYE_BROWN_HEADER = "WHAT’S INCLUDED";
export const CONTENT_BLOCKER_TITLE = "Topics that drive success with customers";
export const CONTENT_BLOCKER_SUB_TITLE = "Our program provides you with the methodologies and frameworks, best practices, and services-specific insights so you have the tools you need to validate, endorse, and successfully develop a practice with services delivery consultants.";
export const FRAME_QUOTE = "“Becoming Dynatrace Services Endorsed has allowed us to achieve tremendous growth with our customers. Through the delivery of Dynatrace’s observability and security solution, we have driven large-scale seven figure projects with customers yielding 7x services revenue for every dollar of Dynatrace consumed.”";
export const QUOTE_SIGN = "Martin Doornbusch";
export const QUOTE_JOB_TITLE = "Head of Digital Performance Management Operations, Eviden";

// --

// SIGN UP
export const SIGN_UP_TITLE = "Maximize skills. Modernize Clouds. Multiply sales.";
export const SIGN_UP_SUB_TITLE = "If you're already Professional Certified and ready to start the Services Program, head to Dynatrace University through the link below to get started.";
export const BANNER_LINK = "https://university.dynatrace.com/ondemand/course/35226?content=overview";
export const BUTTON_NAME_SIGN_UP = "Get started";
// --



